<script setup lang="ts">
import PageError404 from '@booking/components/PageError404.vue'
import { usePageTitle } from '@booking/utils/usePageSettings'
import DevelopmentEnvironment from '@sub/components/development/DevelopmentEnvironment.vue'

usePageTitle('404')
</script>

<template lang="pug">
NuxtLayout(name="error")
  PageError404.h-100p
.position-fixed.z-index-500#bottom-sheet
DevelopmentEnvironment
</template>
